import type { GetIntlDisplayNamesProps } from "./types";

export const getIntlDisplayNames = ({ currentLocale, type }: GetIntlDisplayNamesProps) => {
  // the formatjs polyfills do not support pt-br, so use pt as the next best option
  const locale = currentLocale === "pt-br" ? "pt" : currentLocale;

  // eslint-disable-next-line local-eslint-rules/enforce-intl-wrapper-use
  return new Intl.DisplayNames([locale], { type });
};
